/**
 * Milagron - Beden Tablosu (Size Chart) Renderer
 *
 * Ürün sayfasında çalışır:
 *   1. URL /products/{handle} ise tetiklenir
 *   2. Shopify product ID'sini bulur (ShopifyAnalytics → product.js fallback)
 *   3. /apps/efx-mila proxy üzerinden getSizeChart çağırır
 *   4. Yanıt varsa tema'nın details-disclosure markup'ıyla bir akordiyon kurar
 *      ve "Açıklama" akordiyonun hemen ALTINA yerleştirir
 *
 * Tema dosyalarına dokunmadan tek <script src=...> ile entegre olur.
 */
(function () {
    'use strict';

    var DEBUG = false;
    function dbg() { if (DEBUG && window.console) console.log.apply(console, ['[size-chart]'].concat([].slice.call(arguments))); }
    function dbgWarn() { if (window.console) console.warn.apply(console, ['[size-chart]'].concat([].slice.call(arguments))); }

    if (!/\/products\/[^\/?#]+/.test(window.location.pathname)) {
        dbg('not a product page, skipping');
        return;
    }

    if (window.__efxSizeChartLoaded) return;
    window.__efxSizeChartLoaded = true;

    // ============================================================
    // Proxy
    // ============================================================
    async function sendToProxy(payload) {
        dbg('proxy →', payload.action, payload);
        try {
            var r = await fetch('/apps/efx-mila', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(payload)
            });
            if (!r.ok) throw new Error('HTTP ' + r.status);
            var json = await r.json();
            dbg('proxy ←', payload.action, json);
            return json;
        } catch (e) {
            dbgWarn('proxy hata', payload.action, e.message);
            return null;
        }
    }

    // ============================================================
    // Product ID tespiti
    // ============================================================
    function getProductIdSync() {
        try {
            if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id) {
                return String(window.ShopifyAnalytics.meta.product.id);
            }
        } catch (e) {}
        var el = document.querySelector('[data-product-id]');
        if (el && el.dataset.productId) return String(el.dataset.productId);
        return null;
    }

    async function getProductIdAsync() {
        var sync = getProductIdSync();
        if (sync) return sync;
        var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
        if (!m) return null;
        try {
            var r = await fetch('/products/' + m[1] + '.js', { headers: { Accept: 'application/json' } });
            if (!r.ok) return null;
            var p = await r.json();
            return p && p.id ? String(p.id) : null;
        } catch (e) {
            dbgWarn('product.js fetch hata', e.message);
            return null;
        }
    }

    // ============================================================
    // Akordiyon yerleştirme
    // ============================================================
    function findAciklamaAccordion() {
        var nodes = document.querySelectorAll('.product-info-accordion');
        for (var i = 0; i < nodes.length; i++) {
            var summary = nodes[i].querySelector('.disclosure__title, summary');
            if (summary) {
                var t = (summary.textContent || '').trim().toLowerCase();
                if (t === 'açıklama' || t === 'aciklama' || t === 'description') {
                    return nodes[i];
                }
            }
        }
        return null;
    }

    function findFallbackAnchor() {
        var first = document.querySelector('.product-info-accordion');
        if (first) return first;
        return null;
    }

    function buildAccordion(sizeChart) {
        var wrap = document.createElement('div');
        wrap.className = 'product-info-accordion efx-size-chart-accordion';
        wrap.innerHTML =
            '<details-disclosure>' +
            '  <details class="disclosure">' +
            '    <summary class="disclosure__title">Beden Tablosu</summary>' +
            '    <div class="disclosure__panel has-motion">' +
            '      <div class="disclosure__content rte cf"></div>' +
            '    </div>' +
            '  </details>' +
            '</details-disclosure>';

        var contentHost = wrap.querySelector('.disclosure__content');
        if (contentHost) contentHost.innerHTML = sizeChart.htmlContent || '';

        return wrap;
    }

    function renderAccordion(sizeChart) {
        if (document.querySelector('.efx-size-chart-accordion')) {
            dbg('zaten yerleştirilmiş');
            return;
        }

        var anchor = findAciklamaAccordion() || findFallbackAnchor();
        if (!anchor) {
            dbgWarn('yerleştirilecek bir akordiyon bulunamadı');
            return;
        }

        var node = buildAccordion(sizeChart);
        anchor.insertAdjacentElement('afterend', node);
        dbg('akordiyon yerleştirildi');

        injectStyles();
        enableImageInteractions(node);
    }

    // ============================================================
    // Stil
    // ============================================================
    function injectStyles() {
        if (document.getElementById('efx-sc-style')) return;
        var style = document.createElement('style');
        style.id = 'efx-sc-style';
        style.textContent = [
            /* Accordion içi görsel */
            '.efx-size-chart-accordion .disclosure__content img{cursor:zoom-in;transition:opacity .15s;display:block;max-width:100%;height:auto;}',
            '.efx-size-chart-accordion .disclosure__content img:hover{opacity:.95;}',
            '.efx-size-chart-accordion .disclosure__content table{width:100%;border-collapse:collapse;}',
            '.efx-size-chart-accordion .disclosure__content > div{width:100%;overflow-x:auto;}',

            /* Lightbox */
            '.efx-sc-lb{position:fixed;inset:0;background:rgba(0,0,0,.92);z-index:99999;display:flex;align-items:center;justify-content:center;animation:efxScLbFade .2s ease;overflow:hidden;touch-action:none;user-select:none;-webkit-user-select:none;}',
            '.efx-sc-lb__stage{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;overflow:hidden;}',
            '.efx-sc-lb__img{max-width:95vw;max-height:92vh;width:auto;height:auto;object-fit:contain;display:block;box-shadow:0 25px 60px rgba(0,0,0,.5);background:#fff;animation:efxScLbZoom .2s ease;transform-origin:center center;will-change:transform;cursor:zoom-in;-webkit-user-drag:none;user-drag:none;-webkit-touch-callout:none;}',
            '.efx-sc-lb.is-zoomed .efx-sc-lb__img{cursor:grab;}',
            '.efx-sc-lb.is-grabbing .efx-sc-lb__img{cursor:grabbing;}',
            '.efx-sc-lb__close{position:absolute;top:16px;right:20px;width:44px;height:44px;border-radius:50%;border:none;background:rgba(255,255,255,.12);color:#fff;font-size:28px;line-height:1;cursor:pointer;font-family:inherit;display:flex;align-items:center;justify-content:center;transition:background .15s;z-index:2;}',
            '.efx-sc-lb__close:hover{background:rgba(255,255,255,.22);}',
            '.efx-sc-lb__zoom{position:absolute;top:16px;left:20px;display:flex;gap:8px;z-index:2;}',
            '.efx-sc-lb__zoom button{width:40px;height:40px;border-radius:50%;border:none;background:rgba(255,255,255,.12);color:#fff;font-size:20px;line-height:1;cursor:pointer;font-family:inherit;display:flex;align-items:center;justify-content:center;transition:background .15s;}',
            '.efx-sc-lb__zoom button:hover{background:rgba(255,255,255,.22);}',
            '.efx-sc-lb__zoom button:disabled{opacity:.4;cursor:not-allowed;}',
            '.efx-sc-lb__hint{position:absolute;bottom:18px;left:50%;transform:translateX(-50%);color:rgba(255,255,255,.6);font-size:12px;letter-spacing:.3px;pointer-events:none;text-align:center;line-height:1.5;padding:0 16px;}',
            '@keyframes efxScLbFade{from{opacity:0;}to{opacity:1;}}',
            '@keyframes efxScLbZoom{from{opacity:0;transform:scale(.92);}to{opacity:1;transform:scale(1);}}',
            '@media(max-width:600px){.efx-sc-lb__close{top:10px;right:10px;width:38px;height:38px;font-size:24px;}.efx-sc-lb__zoom{top:10px;left:10px;}.efx-sc-lb__zoom button{width:36px;height:36px;font-size:18px;}.efx-sc-lb__hint{font-size:11px;bottom:12px;}}'
        ].join('\n');
        document.head.appendChild(style);
    }

    // ============================================================
    // Lightbox + pan-zoom + pinch
    // ============================================================
    function openLightbox(src, alt) {
        var lb = document.createElement('div');
        lb.className = 'efx-sc-lb';
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-modal', 'true');
        lb.setAttribute('aria-label', 'Beden Tablosu (Büyük Görünüm)');
        lb.innerHTML =
            '<div class="efx-sc-lb__zoom">' +
            '  <button type="button" data-zoom="out" aria-label="Uzaklaştır">−</button>' +
            '  <button type="button" data-zoom="reset" aria-label="Sıfırla">⊙</button>' +
            '  <button type="button" data-zoom="in" aria-label="Yakınlaştır">+</button>' +
            '</div>' +
            '<button type="button" class="efx-sc-lb__close" aria-label="Kapat">&times;</button>' +
            '<div class="efx-sc-lb__stage"><img class="efx-sc-lb__img" alt=""></div>' +
            '<div class="efx-sc-lb__hint"></div>';

        var stage = lb.querySelector('.efx-sc-lb__stage');
        var img = lb.querySelector('.efx-sc-lb__img');
        var hint = lb.querySelector('.efx-sc-lb__hint');
        var btnIn = lb.querySelector('[data-zoom="in"]');
        var btnOut = lb.querySelector('[data-zoom="out"]');
        var btnReset = lb.querySelector('[data-zoom="reset"]');

        var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
        hint.textContent = isTouch
            ? 'Çift dokun veya parmaklarla yakınlaştır • Sürükleyerek gez'
            : 'Tıkla veya scroll ile yakınlaştır • Sürükleyerek gez • ESC kapat';

        img.src = src;
        if (alt) img.alt = alt;

        // Transform state — transform-origin: center center
        // panX,panY: img merkezinin stage merkezine göre offset'i (px). 0,0 = ortalı.
        var scale = 1;
        var minScale = 1;
        var maxScale = 6;
        var panX = 0, panY = 0;
        var baseW = 0, baseH = 0; // img'in scale=1'deki sığdırılmış boyutu
        var stageW = 0, stageH = 0;

        function applyTransform() {
            // transform-origin merkezde olduğu için scale önce uygulanır gibi davranır;
            // translate(panX,panY) image'ı kendi merkezine göre kaydırır
            img.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
            lb.classList.toggle('is-zoomed', scale > 1.001);
            updateButtons();
        }

        function updateButtons() {
            btnOut.disabled = scale <= minScale + 0.001;
            btnIn.disabled = scale >= maxScale - 0.001;
        }

        function clampPan() {
            // Ölçekli boyut
            var sw = baseW * scale;
            var sh = baseH * scale;

            // Image sahneye sığıyorsa pan sıfırla (ortalı kalsın)
            if (sw <= stageW) {
                panX = 0;
            } else {
                // Image'ın sol/sağ kenarı stage kenarından dışa taşmasın
                // Image sol kenarı (stage-relative): stageW/2 + panX - sw/2
                // ≥ 0 ve image sağ kenarı (stageW/2 + panX + sw/2) ≤ stageW olmalı
                var maxPanX = (sw - stageW) / 2;
                panX = Math.max(-maxPanX, Math.min(maxPanX, panX));
            }
            if (sh <= stageH) {
                panY = 0;
            } else {
                var maxPanY = (sh - stageH) / 2;
                panY = Math.max(-maxPanY, Math.min(maxPanY, panY));
            }
        }

        function measure() {
            // Stage ve img'in scale=1'deki "doğal" sığdırılmış boyutunu ölç
            var prevTransform = img.style.transform;
            img.style.transform = 'none';
            // reflow zorla
            void img.offsetWidth;
            var stageRect = stage.getBoundingClientRect();
            stageW = stageRect.width;
            stageH = stageRect.height;
            baseW = img.clientWidth;
            baseH = img.clientHeight;
            img.style.transform = prevTransform;
        }

        function reset() {
            scale = 1;
            panX = 0;
            panY = 0;
            measure();
            applyTransform();
        }

        // Belirli bir ekran noktası sabit kalacak şekilde zoom
        function zoomAt(clientX, clientY, newScale) {
            newScale = Math.max(minScale, Math.min(maxScale, newScale));
            if (newScale === scale) return;

            var stageRect = stage.getBoundingClientRect();
            var sx = clientX - stageRect.left;   // stage içi x
            var sy = clientY - stageRect.top;    // stage içi y
            var cx = stageW / 2;                  // stage merkezi
            var cy = stageH / 2;

            // Hedef noktanın image-merkezine göre offset'i (current scale altında)
            var dx = sx - (cx + panX);
            var dy = sy - (cy + panY);

            // Image-koordinatlarında (scale=1) offset
            var ix = dx / scale;
            var iy = dy / scale;

            scale = newScale;

            // Yeni durumda aynı image noktası (sx,sy)'de kalsın:
            // sx = cx + panX_new + ix*scale  →  panX_new = sx - cx - ix*scale
            panX = sx - cx - ix * scale;
            panY = sy - cy - iy * scale;

            clampPan();
            applyTransform();
        }

        function zoomCenter(newScale) {
            var stageRect = stage.getBoundingClientRect();
            zoomAt(stageRect.left + stageW / 2, stageRect.top + stageH / 2, newScale);
        }

        // ---- Wheel zoom ----
        function onWheel(e) {
            e.preventDefault();
            var delta = -e.deltaY;
            var factor = delta > 0 ? 1.15 : 1 / 1.15;
            zoomAt(e.clientX, e.clientY, scale * factor);
        }

        // ---- Pointer (drag pan + pinch + tap-to-zoom) ----
        var pointers = {};         // id → {x,y}
        var dragStart = null;      // {x,y, panX, panY}
        var pinchStart = null;     // {dist, scale, midX, midY, panX, panY}
        var tapStart = null;       // {x,y,t,id} — tek pointer için tap tespiti
        var lastTapTime = 0;       // çift dokunuş için
        var lastTapPos = null;
        var TAP_MOVE_THRESHOLD = 6;   // px, bu kadar veya daha az hareket = tap
        var DOUBLE_TAP_MS = 300;

        function pointerDist() {
            var ids = Object.keys(pointers);
            if (ids.length < 2) return 0;
            var a = pointers[ids[0]], b = pointers[ids[1]];
            var dx = a.x - b.x, dy = a.y - b.y;
            return Math.sqrt(dx * dx + dy * dy);
        }
        function pointerMid() {
            var ids = Object.keys(pointers);
            var a = pointers[ids[0]], b = pointers[ids[1]];
            return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        }

        function onPointerDown(e) {
            // Sadece sahne ya da img üstündekileri yakala
            if (e.target !== img && e.target !== stage) return;
            // Sol tık (mouse) dışındakileri görmezden gel
            if (e.pointerType === 'mouse' && e.button !== 0) return;

            stage.setPointerCapture && stage.setPointerCapture(e.pointerId);
            pointers[e.pointerId] = { x: e.clientX, y: e.clientY };

            var ids = Object.keys(pointers);
            if (ids.length === 1) {
                // Tap adayı kaydet (pointerup'ta hareket az olduysa "tap" sayılacak)
                tapStart = { x: e.clientX, y: e.clientY, t: Date.now(), id: e.pointerId };
                if (scale > 1.001) {
                    dragStart = { x: e.clientX, y: e.clientY, panX: panX, panY: panY };
                    lb.classList.add('is-grabbing');
                }
            } else if (ids.length === 2) {
                tapStart = null;
                dragStart = null;
                var d = pointerDist();
                var m = pointerMid();
                pinchStart = { dist: d, scale: scale, midX: m.x, midY: m.y, panX: panX, panY: panY };
            }
        }

        function onPointerMove(e) {
            if (!(e.pointerId in pointers)) return;
            pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
            var ids = Object.keys(pointers);

            // Hareket eşiği aşıldıysa tap adaylığını iptal et
            if (tapStart && e.pointerId === tapStart.id) {
                var mdx = e.clientX - tapStart.x;
                var mdy = e.clientY - tapStart.y;
                if (Math.sqrt(mdx * mdx + mdy * mdy) > TAP_MOVE_THRESHOLD) {
                    tapStart = null;
                }
            }

            if (ids.length === 2 && pinchStart) {
                e.preventDefault();
                var d = pointerDist();
                if (!d) return;
                var m = pointerMid();
                var newScale = Math.max(minScale, Math.min(maxScale, pinchStart.scale * (d / pinchStart.dist)));

                // Pinch başlangıçtaki midpoint'in image-koordinatlarındaki sabit noktasını bul
                var stageRect = stage.getBoundingClientRect();
                var cx = stageW / 2, cy = stageH / 2;
                var sx0 = pinchStart.midX - stageRect.left;
                var sy0 = pinchStart.midY - stageRect.top;
                var ix = (sx0 - cx - pinchStart.panX) / pinchStart.scale;
                var iy = (sy0 - cy - pinchStart.panY) / pinchStart.scale;

                // Güncel midpoint (kullanıcı parmaklarını kaydırabilir)
                var sxN = m.x - stageRect.left;
                var syN = m.y - stageRect.top;

                scale = newScale;
                panX = sxN - cx - ix * scale;
                panY = syN - cy - iy * scale;
                clampPan();
                applyTransform();
            } else if (ids.length === 1 && dragStart) {
                var dx = e.clientX - dragStart.x;
                var dy = e.clientY - dragStart.y;
                panX = dragStart.panX + dx;
                panY = dragStart.panY + dy;
                clampPan();
                applyTransform();
            }
        }

        function onPointerUp(e) {
            var wasTap = false;
            var tapX = 0, tapY = 0;
            if (tapStart && e.pointerId === tapStart.id) {
                var mdx = e.clientX - tapStart.x;
                var mdy = e.clientY - tapStart.y;
                if (Math.sqrt(mdx * mdx + mdy * mdy) <= TAP_MOVE_THRESHOLD) {
                    wasTap = true;
                    tapX = e.clientX;
                    tapY = e.clientY;
                }
                tapStart = null;
            }

            delete pointers[e.pointerId];
            var ids = Object.keys(pointers);
            if (ids.length < 2) pinchStart = null;
            if (ids.length === 0) {
                dragStart = null;
                lb.classList.remove('is-grabbing');
            } else if (ids.length === 1 && scale > 1.001) {
                // Pinchten tek parmağa düştü → drag'a geç
                var only = pointers[ids[0]];
                dragStart = { x: only.x, y: only.y, panX: panX, panY: panY };
            }

            // Tek tıklama / dokunma → zoom toggle
            if (wasTap && ids.length === 0) {
                var now = Date.now();
                var isDouble = false;
                if (e.pointerType === 'touch' && lastTapPos) {
                    var ddx = tapX - lastTapPos.x;
                    var ddy = tapY - lastTapPos.y;
                    if (now - lastTapTime < DOUBLE_TAP_MS && Math.sqrt(ddx * ddx + ddy * ddy) < 30) {
                        isDouble = true;
                    }
                }

                if (e.pointerType === 'touch') {
                    if (isDouble) {
                        if (scale > 1.001) reset();
                        else zoomAt(tapX, tapY, 2.5);
                        lastTapTime = 0;
                        lastTapPos = null;
                    } else {
                        // tek dokunuş → bekle (double-tap olabilir), bir şey yapma
                        lastTapTime = now;
                        lastTapPos = { x: tapX, y: tapY };
                    }
                } else {
                    // mouse / pen → tek tıkla toggle
                    if (scale > 1.001) reset();
                    else zoomAt(tapX, tapY, 2.5);
                }
            }
        }

        // ---- Kapat ----
        function close() {
            lb.remove();
            document.removeEventListener('keydown', escHandler);
            window.removeEventListener('resize', onResize);
            document.body.style.overflow = '';
        }
        function escHandler(e) {
            if (e.key === 'Escape') close();
            else if (e.key === '+' || e.key === '=') zoomCenter(scale * 1.25);
            else if (e.key === '-') zoomCenter(scale / 1.25);
            else if (e.key === '0') reset();
        }
        function onResize() {
            // Reset ile yeniden ortala
            reset();
        }

        lb.querySelector('.efx-sc-lb__close').addEventListener('click', close);
        lb.addEventListener('click', function (e) {
            // Sadece arka plana tıklayınca kapansın (img veya butonlar değil)
            if (e.target === lb) close();
        });
        btnIn.addEventListener('click', function () { zoomCenter(scale * 1.4); });
        btnOut.addEventListener('click', function () { zoomCenter(scale / 1.4); });
        btnReset.addEventListener('click', reset);

        img.addEventListener('dragstart', function (e) { e.preventDefault(); });
        stage.addEventListener('wheel', onWheel, { passive: false });

        // Pointer events stage üstünde — pinch/drag
        stage.addEventListener('pointerdown', onPointerDown);
        stage.addEventListener('pointermove', onPointerMove);
        stage.addEventListener('pointerup', onPointerUp);
        stage.addEventListener('pointercancel', onPointerUp);

        document.addEventListener('keydown', escHandler);
        window.addEventListener('resize', onResize);

        document.body.style.overflow = 'hidden';
        document.body.appendChild(lb);

        // Img yüklenince ölç
        if (img.complete && img.naturalWidth) {
            measure();
            applyTransform();
        } else {
            img.addEventListener('load', function () {
                measure();
                applyTransform();
            }, { once: true });
        }
    }

    function enableImageInteractions(rootNode) {
        var imgs = rootNode.querySelectorAll('.disclosure__content img');
        for (var i = 0; i < imgs.length; i++) {
            (function (img) {
                img.addEventListener('click', function () {
                    openLightbox(img.currentSrc || img.src, img.alt || 'Beden Tablosu');
                });
            })(imgs[i]);
        }
    }

    // ============================================================
    // Init
    // ============================================================
    async function init() {
        var pid = await getProductIdAsync();
        if (!pid) {
            dbgWarn('product id bulunamadı');
            return;
        }
        dbg('product id:', pid);

        var resp = await sendToProxy({ action: 'getSizeChart', productId: pid });
        if (!resp || !resp.ok) {
            dbg('beklenmeyen yanıt');
            return;
        }
        if (!resp.hasSizeChart || !resp.sizeChart || !resp.sizeChart.htmlContent) {
            dbg('size chart yok');
            return;
        }

        renderAccordion(resp.sizeChart);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();